/**
 * 関連資料の件数と大きさの上限。
 * バックエンドの `real_estate_research_request/const.py` と同じ値にそろえる。
 */
export const MAX_RELATED_FILES = 10;
export const MAX_RELATED_FILE_MB = 20;
export const MAX_RELATED_FILES_TOTAL_MB = 50;

const BYTES_PER_MB = 1024 * 1024;
export const MAX_RELATED_FILE_BYTES = MAX_RELATED_FILE_MB * BYTES_PER_MB;
export const MAX_RELATED_FILES_TOTAL_BYTES =
  MAX_RELATED_FILES_TOTAL_MB * BYTES_PER_MB;
